import { Button } from '@/components/ui/button';
import { ShoppingBag } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface EmptyCartStateProps {
  onBrowseMenu?: () => void;
}

export function EmptyCartState({ onBrowseMenu }: EmptyCartStateProps) {
  const { t } = useTranslation('customer');

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <ShoppingBag 
        className="h-16 w-16 text-muted-foreground mb-4" 
        strokeWidth={1.5}
        aria-hidden="true"
      />
      <h3 className="text-lg font-semibold text-center mb-2">
        {t('cart.empty')}
      </h3>
      <p className="text-sm text-muted-foreground text-center mb-6 max-w-xs">
        {t('cart.emptySubtext')}
      </p>
      {onBrowseMenu && (
        <Button 
          variant="outline" 
          onClick={onBrowseMenu}
          className="min-w-[180px]"
        >
          {t('cart.browseMenu')}
        </Button>
      )}
    </div>
  );
}
